import { COLLECTIONS, isValidPayload, store, toErrorResult } from './shared';

const hasCriticalField = payload => Boolean(payload && (payload.titulo || payload.nome));

const normalizeModelo = payload => {
  const label = payload && payload.label ? payload.label : payload && payload.titulo;
  const titulo = payload && payload.titulo ? payload.titulo : payload && payload.label;

  return {
    ...payload,
    label: label || '',
    titulo: titulo || '',
    descricao: (payload && payload.descricao) || '',
    qtd_questoes: (payload && payload.qtd_questoes) || 0,
    questoes: Array.isArray(payload && payload.questoes) ? payload.questoes : []
  };
};

const create = async payload => {
  if (!isValidPayload(payload)) {
    return toErrorResult(new Error('Payload inválido para criação de modelo'));
  }

  if (!hasCriticalField(payload)) {
    return toErrorResult(new Error('Payload de modelo sem campos críticos'));
  }

  return store.create(COLLECTIONS.modelos, normalizeModelo(payload));
};

const update = async (id, payload) => {
  if (!isValidPayload(payload)) {
    return toErrorResult(new Error('Payload inválido para atualização de modelo'));
  }

  if (!hasCriticalField(payload)) {
    return toErrorResult(new Error('Payload de modelo sem campos críticos'));
  }

  return store.update(COLLECTIONS.modelos, id, normalizeModelo(payload));
};

const modelosRepo = {
  list: async () => {
    const result = await store.list(COLLECTIONS.modelos);

    if (!result.ok) {
      return result;
    }

    const items = Array.isArray(result.data) ? result.data.map(normalizeModelo) : [];
    return { ok: true, data: items, error: null };
  },
  getById: async id => store.getById(COLLECTIONS.modelos, id),
  create,
  update,
  remove: async id => store.remove(COLLECTIONS.modelos, id)
};

export default modelosRepo;
